import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 80 80"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M79.558 39.779c0 21.969-17.81 39.779-39.779 39.779C17.81 79.558 0 61.748 0 39.779 0 17.81 17.81 0 39.779 0c21.969 0 39.779 17.81 39.779 39.779Zm-24.312 22.65a9.29 9.29 0 0 0 3.39-.612c3.554-1.384 5.098-4.745 5.593-6.113l.07-.192c.24-.642.804-2.147-.874-3.375l-8.629-5.656c-3.091-1.84-6.155.479-7.627 1.594-.256.194-1.525 1.114-2.771.125L32.493 36.437c-1.395-1.234-.276-2.353.116-2.77 1.265-1.346 3.436-4.535 1.571-7.665l-5.618-8.569c-1.029-1.737-2.812-1.101-3.485-.86l-.083.03c-1.381.499-4.742 2.043-6.125 5.597-1.189 3.054-.647 6.792 1.611 11.112 3.547 6.786 14.027 20.089 27.043 26.893 2.835 1.481 5.419 2.224 7.723 2.224Z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon_phone"}) } }